import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { createStore, applyMiddleware, combineReducers } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
export default (function (reducers, initialState, middlewares) {
  var reducer = combineReducers(reducers);
  var enhancer = applyMiddleware.apply(void 0, _toConsumableArray(middlewares).concat([thunk, promise]));
  return createStore(reducer, initialState, enhancer);
});


//////////////////
// WEBPACK FOOTER
// /Users/dmp/Code/catbirdproductions.ca/node_modules/@folklore/react-container/es/configureStore.prod.js
// module id = null
// module chunks = 